<template>
	<article>
		<PushController v-if="ready" ref="push" />
	</article>
</template>

<script>
	import PushController from '@/components/manage/PushController.vue';

	export default {
		name: 'PushInquiry',
		components: { PushController },
		data() {
			return {
				ready: false,
			};
		},
		async created() {
			this.$store.commit('PushController/mutationValue', [
				{ key: 'isInquiry', value: true },
			]);
			await this.initNotiId();
		},
		beforeDestroy() {
			this.$store.commit('PushController/mutationValue', [
				{ key: 'isInquiry', value: false },
			]);
		},
		methods: {
			async initNotiId() {
				this.$store.commit('PushController/init');
				const idNoti = this.$route.params.idNoti;
				const idNotiSchedule = this.$route.params.idNotiSchedule;
				await this.$store.dispatch('PushController/inquiry', {
					idNoti,
					idNotiSchedule,
				});
				this.ready = true;
				this.$nextTick(() => {
					this.$refs.push.getSampleLink();
				});
			},
		},
	};
</script>
